import { render } from "./BottomListPhotoTagsProp.vue?vue&type=template&id=41540e80&scoped=true"
import script from "./BottomListPhotoTagsProp.vue?vue&type=script&lang=js"
export * from "./BottomListPhotoTagsProp.vue?vue&type=script&lang=js"

import "./BottomListPhotoTagsProp.vue?vue&type=style&index=0&id=41540e80&scoped=true&lang=less"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41540e80"]])

export default __exports__